import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Pure (React-free) error-type constants + classifier shared by the bridge layer
 * (`bridge/methods/core.ts`, `bridge/middleware/withErrorDisplay.ts`) and the React
 * error components in this folder. Kept free of component imports so the bridge
 * layer can classify errors without pulling React in.
 */

/** Backend `errorType` returned when a Forge app invokes a deprecated sandbox runtime. */
export const SANDBOX_DEPRECATION_ERROR = 'INVALID_INVOCATION_RUNTIME_ERROR';

const DEVELOPER_SPACE_SETUP_INCOMPLETE = 'DEVELOPER_SPACE_SETUP_INCOMPLETE';
const MISSING_DEVELOPER_SPACE = 'MISSING_DEVELOPER_SPACE';

const DEVELOPER_SPACE_ERRORS: ReadonlyArray<string> = [
	DEVELOPER_SPACE_SETUP_INCOMPLETE,
	MISSING_DEVELOPER_SPACE,
];

export const isDeveloperSpaceError = (errorCode: string): boolean => {
	if (!fg('forge-ui-dev-space-error')) {
		return false;
	}
	return DEVELOPER_SPACE_ERRORS.includes(errorCode);
};

/**
 * Whether a (thrown) app error type should take over the surface with an
 * error message, rather than being passed back to the app to handle. Used by
 * `withErrorDisplay` to decide whether to call `services.showAppError`.
 */
export const shouldRenderForgeAppErrorMessage = (error: string): boolean => {
	return isDeveloperSpaceError(error) || error === SANDBOX_DEPRECATION_ERROR;
};
